import { ThemeProvider } from '@material-ui/core';
import { createTheme } from "@material-ui/core/styles";
import axios from "axios";
import MaterialTable from "material-table";
import { Component } from "react";
import { Button, Card, OverlayTrigger, Tooltip } from "react-bootstrap";
import ConfirmModal from "../utils/ConfirmModal";
import { downloadCSV } from "../utils/csvDownload";
import { hasPermission } from "../utils/usePermission";
import CommonLoader from "./loaderComponent/CommonLoader";
import CommonToast from "./Toaster/CommonToast";

import { FaHourglassHalf, FaPencilAlt } from "react-icons/fa";
import PurchaseOrderPDF from "../utils/PurchaseOrderPDF";

export default class PurchaseOrderList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      purchaseOrders: [],
      purchaseOrderPrint: [],
      loading: true,
      showToast: false,
      toastMessage: "",
      toastVariant: "",
      deleteId: null,
      color: '',
      completed: false
    };
  }

  openConfirmModal = () => {
    this.setState({ showConfirm: true, });
  };
  closeConfirmModal = () => {
    this.setState({ showConfirm: false });
  };

  componentDidMount() {
    this.fetchPurchaseOrders();
  }

  fetchPurchaseOrders = () => {
    this.setState({ loading: true });
    axios
      .get("/purchaseOrders")
      .then((res) => {
        this.setState({ purchaseOrders: res.data, loading: false });
      })
      .catch((error) => {
        this.setState({
          loading: false,
          showToast: true,
          toastMessage: error.response?.data?.message || "Error fetching purchase orders",
          toastVariant: "danger",
          color: 'red'
        });
      });
  };

  handleDelete = () => {
    axios
      .delete(`/purchaseOrders/${this.state.deleteId}`)
      .then(() => {
        this.setState({
          showToast: true,
          showConfirm: false,
          toastMessage: "Purchase Order deleted successfully",
          toastVariant: "success",
          color: 'green',
          deleteId: null,
        });
        this.fetchPurchaseOrders();
      })
      .catch((error) => {
        this.setState({
          showToast: true,
          showConfirm: false,
          toastMessage: error.response?.data?.message || "Error deleting purchase order",
          toastVariant: "danger",
          deleteId: null,
          color: 'red'
        });
      });
  };

  handleMoveAdd = () => {
    this.props.history.push('/purchaseOrder-add')
  }


  fetchPurchaseOrdersprint = async (id) => {
    this.setState({ loading: true });

    try {
      const res = await axios.get(`/purchaseOrders/${id}`);
      this.setState({ purchaseOrderPrint: res.data, loading: false, completed: true });
    } catch (error) {

    }
  }


  handlePrint = async (rowData) => {
    const companyInfo = {
      name: rowData.customer.name,
      project: rowData.project.name,
    }

    // const companyInfo = {
    //   name: "Snap Solutions Pvt Ltd",
    //   registered_Office: "209-A TARA SADAN, Shri Krishna Avenue, Khandwa Road, Limbodi, Indore, (MP) 452001",
    //   email: "projects@snapsolutions.in",
    //   phone: "+91 75090 78787",
    //   Website: "www.snapsolutions.in",
    //   phone: "+91 44 2267 6000",
    //   PAN: 'AABCG0949C',
    //   CIN_No: "U43900MP2023PTC065127",
    //   terms: [
    //   ],
    //   footerText: "Terms and conditions apply"
    // };

    try {
      await this.fetchPurchaseOrdersprint(rowData.id);
      // Convert image to base64
      // const response = await fetch(LogoPath);
      // const blob = await response.blob();
      const logoBase64 = ''
      // const logoBase64 = await new Promise((resolve) => {
      //   const reader = new FileReader();
      //   reader.onloadend = () => resolve(reader.result);
      //   reader.readAsDataURL(blob);
      // });
      if (this.state.completed && this.state.purchaseOrderPrint) {
        await PurchaseOrderPDF.generate(this.state.purchaseOrderPrint, logoBase64, companyInfo);
      }

    } catch (error) {
      console.error('Failed to generate PDF:', error);
      alert('Failed to generate PDF. Please check console for details.');
    }
  };

  handlePrintAll = () => {
    // debugger;
    const { deliveryChallans } = this.state
    console.log("first", deliveryChallans)
    if (deliveryChallans) {
      downloadCSV(deliveryChallans, "Challans_Info");
    }
  }

  handleEdit = (rowData) => {
    const { id } = rowData;
    this.props.history.push(`/PurchaseOrder-edit/${id}`, { data: rowData });
  };
  handleView = (rowData, viewPage) => {
    // console.log("rowData", rowData);
    const { id } = rowData;
    this.props.history.push(`/PurchaseOrder-view/${id}`, { data: rowData, viewPage });
  };

  render() {
    const { purchaseOrders, loading, showToast, toastMessage, toastVariant } = this.state;
    const theme = createTheme({
      overrides: {
        MuiTableCell: {
          root: {
            padding: '6px 6px 6px 6px'
          }
        }
      }
    })
    return (
      <>
        <CommonToast
          show={showToast}
          onClose={() => this.setState({ showToast: false })}
          message={toastMessage}
          variant={toastVariant}
          color={this.state.color}
        />
        <ConfirmModal
          show={this.state.showConfirm}
          onHide={() => this.setState({ showConfirm: false, deleteId: null })}
          onConfirm={() => this.handleDelete()}
          title="Delete Confirmation"
          message="Are you sure you want to delete this Purchase Order?"
        />
        <CommonLoader isLoading={loading}>
          <div className="container-fluid pt-4">
            <div className='d-flex search-btn-gap challan-print'>
              {
                hasPermission('M18B1') && (
                  <div className='add-role'>
                    <Button variant="primary" className="d-flex align-items-center gap-2 px-4 py-2 rounded-pill shadow-sm custom-add-button" onClick={this.handleMoveAdd}> <i className="fa fa-plus-circle"></i> Add Purchase Order</Button>
                  </div>
                )
              }
              <div className="print-button">
                {
                  hasPermission('M18B6') && (
                    <Button variant="outline-primary" onClick={this.handlePrintAll} ><i className="fa fa-print"></i></Button>
                  )}
              </div>
            </div>
            <div className="col-sm-12">
              <Card>
                <Card.Header style={{ backgroundColor: "#515e73", color: "white" }}>
                  <div className="panel-title">
                    <strong>Purchase Orders List</strong>
                  </div>
                </Card.Header>
                <Card.Body>
                  <ThemeProvider theme={theme}>
                    <MaterialTable
                      title="Purchase Orders"
                      columns={[
                        {
                          title: "ID", field: "id", editable: "never"
                        },
                        {
                          title: "PO Number", field: "poNumber",
                          cellStyle: { minWidth: 150 },
                          headerStyle: { minWidth: 150 }
                        },
                        // {
                        //   title: "PO Date", field: "poDate", type: "date",
                        //   cellStyle: { minWidth: 150 },
                        //   headerStyle: { minWidth: 150 }
                        // },

                        {
                          title: "PO Date",
                          field: "poDate",
                          type: "date",
                          render: rowData => {
                            if (!rowData.poDate) return '';
                            const date = new Date(rowData.poDate);
                            return `${date.getDate().toString().padStart(2, '0')}/${(date.getMonth() + 1)
                              .toString()
                              .padStart(2, '0')}/${date.getFullYear()}`;
                          },
                          cellStyle: { minWidth: 150 },
                          headerStyle: { minWidth: 150 }
                        },
                        {
                          title: "Customer", field: "customer.name",
                          cellStyle: { minWidth: 250 },
                          headerStyle: { minWidth: 250 }
                        },
                        {
                          title: "Project", field: "project.name",
                          cellStyle: { minWidth: 250 },
                          headerStyle: { minWidth: 250 }
                        },

                        {
                          title: "Status",
                          field: "status",
                          cellStyle: { minWidth: 120 },
                          headerStyle: { minWidth: 120 },
                          render: rowData => {
                            const status = rowData?.status;
                            const baseStyle = {
                              display: 'inline-flex',
                              alignItems: 'center',
                              gap: '6px',
                              fontSize: '0.875rem',
                              padding: '4px 12px',
                              borderRadius: '20px',
                              fontWeight: 500
                            };

                            if (status === 'pending') {
                              return (
                                <span style={{
                                  ...baseStyle,
                                  backgroundColor: '#fff3cd',
                                  color: '#664d03',
                                  border: '1px solid #ffe69c'
                                }}>
                                  <FaHourglassHalf /> Pending
                                </span>
                              );
                            } else {
                              return (
                                <span style={{
                                  ...baseStyle,
                                  backgroundColor: '#f8d7da',
                                  color: '#842029',
                                  border: '1px solid #f5c2c7'
                                }}>
                                  <FaPencilAlt /> Draft
                                </span>
                              );
                            }
                          }
                        },

                        {
                          title: "Total Item Value ", field: "status",
                          cellStyle: { minWidth: 120 },
                          headerStyle: { minWidth: 120 },
                          render: rowData => {
                            const totalValue = (rowData.items || []).reduce((sum, item) => {
                              return sum + (parseFloat(item.totalValue) || 0);
                            }, 0);

                            return `₹ ${totalValue.toFixed(2)}`;
                          }
                        },
                        {
                          title: "Action", field: "status",
                          render: rowData => (
                            <>
                              {/* {console.log("this is rowdata", rowData.status)} */}
                              {rowData.status === "draft" ?
                                <>
                                  {hasPermission('M18B2') && (
                                    <OverlayTrigger
                                      placement="top"
                                      overlay={<Tooltip id={`tooltip-edit-${rowData.id}`}>Edit  Purchase Order</Tooltip>}
                                    >
                                      <Button size="sm" variant="outline-info" className="mr-2 info"
                                        onClick={() => this.handleEdit(rowData)}
                                      >
                                        <i className="fa fa-edit"></i>
                                      </Button>
                                    </OverlayTrigger>
                                  )}
                                </>
                                : ""}
                              {hasPermission('M18B4') && (
                                <OverlayTrigger
                                  placement="top"
                                  overlay={<Tooltip id={`tooltip-delete-${rowData.id}`}>View  Purchase Order</Tooltip>}
                                >
                                  <Button size="sm" variant="outline-info" className="mr-2 info"
                                    onClick={() => this.handleView(rowData, "viewPage")}
                                  >
                                    <i className="fa fa-eye"></i>
                                  </Button>
                                </OverlayTrigger>
                              )}
                              {hasPermission('M18B3') && (
                                <OverlayTrigger
                                  placement="top"
                                  overlay={<Tooltip id={`tooltip-delete-${rowData.id}`}>Delete Purchase Order</Tooltip>}
                                >
                                  <Button size="sm" className="mr-2 delete-btn" variant="outline-danger"
                                    onClick={() => this.setState({ showConfirm: true, deleteId: rowData.id })}
                                  // onClick={() => this.handleDelete(rowData.citemid)}
                                  >
                                    <i className="fas fa-trash"></i>
                                  </Button>
                                </OverlayTrigger>
                              )}
                              {
                                //rowData.status != 'Paid' &&
                                hasPermission('M18B7') && (
                                  <OverlayTrigger
                                    placement="top"
                                    overlay={<Tooltip id={`tooltip-print-${rowData.id}`}>Print Purchase Order</Tooltip>}
                                  >
                                    <Button
                                      size="sm"
                                      variant="outline-info"
                                      className="mr-2 info"
                                      onClick={() => this.handlePrint(rowData)}
                                    >
                                      <i className="fa fa-print"></i>
                                    </Button>
                                  </OverlayTrigger>
                                )
                              }
                            </>
                          ),
                          cellStyle: { width: '200px', minWidth: '200px', textAlign: 'center' }, // Adjust width as needed
                          headerStyle: { width: '200px', minWidth: '200px', textAlign: 'center' }
                        },
                      ]}
                      data={purchaseOrders}
                      actions={[
                        // {
                        //   icon: "add",
                        //   tooltip: "Add Purchase Order",
                        //   isFreeAction: true,
                        //   onClick: () => this.props.history.push("/purchaseOrder-add"),
                        // },
                        // {
                        //   icon: "edit",
                        //   tooltip: "Edit Purchase Order",
                        //   onClick: (event, rowData) => this.props.history.push(`/purchaseOrder-edit/${rowData.id}`),
                        //   //disabled: (rowData) => rowData.status === "pending",
                        // },


                        //   {
                        //       icon: "delete",
                        // tooltip: "Delete Purchase Order",
                        //       onClick: (event, rowData) => this.handleDelete(rowData.id),
                        //     },
                      ]}
                      options={{
                        pageSize: 10,
                        pageSizeOptions: [10, 20, 30, 50, 75, 100],
                        rowStyle: (rowData, index) => {
                          if (index % 2) {
                            return { backgroundColor: '#f2f2f2' }
                          }
                        },
                        actionsColumnIndex: -1,
                        search: true,
                        paging: true,
                      }}
                    />
                  </ThemeProvider>
                </Card.Body>
              </Card>
            </div>
          </div>
        </CommonLoader>
      </>
    );
  }
}
